module.exports = __webpack_public_path__ + "img/6.a716c913.svg";